// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__v4qlX","intro":"home_intro__2Yshs","products":"home_products__1J9cG","title":"home_title__3_sLh"};